import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VRow,[_c(VCol,[_c('Meal2',{attrs:{"mealId":_vm.mealId,"date":_vm.date,"read-only":_vm.readOnly}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }